import React from 'react'

import { Avatar } from '@nextui-org/avatar'
import { Button } from '@nextui-org/button'
import { Select, SelectedItems, SelectItem } from '@nextui-org/select'
import Image from 'next/image'
import Link from 'next/link'
import moment from 'moment'

import ICONS from '@/assets/icons'
import { Currency } from '@/types'

import { SearchComponent } from '../SearchHeadBar/SearchComponent'
import styles from './styles.module.css'

export const listCurrency = [
  {
    key: 'usdt',
    label: 'USDT',
  },
  {
    key: 'aiape',
    label: 'AIAPE',
  },
]

export const listSocial = [
  {
    provider: 'twitter',
    icon: ICONS.icXGray,
  },
  {
    provider: 'telegram',
    icon: ICONS.icTeleGray,
  },
  {
    provider: 'discord',
    icon: ICONS.discordGray,
  },
  {
    provider: 'tiktok',
    icon: ICONS.tiktokGray,
  },
  {
    provider: 'youtobe',
    icon: ICONS.youtubeGray,
  },
  {
    provider: 'facebook',
    icon: ICONS.fbGray,
  },
]

export const SidebarKOL = () => {
  return (
    <div className="flex flex-col gap-6">
      <SearchComponent
        debounceSecond={1}
        defaultValue={''}
        handleSearch={(value) => {
          if (value) {
          }
        }}
      />
      <SwapToken />
      <DescriptionProject />
      <OfficialLink />
      <BasicData />
      <div className="flex gap-1 justify-between text-xs text-ss-grayscale-600">
        <Link href="/term-of-use" target="_blank">
          <span>Terms of Service</span>
        </Link>
        <Link href="/privacy-policy" target="_blank">
          <span>Privacy Policy</span>
        </Link>
        <span>©Sightsea {moment().format('YYYY')}</span>
      </div>
    </div>
  )
}

export const SwapToken = () => {
  return (
    <div className="border border-white/10 rounded-xl ">
      <div className="border-b border-white/10 text-center py-3 text-sm font-medium text-ss-grayscale-200">Swap</div>
      <div className="px-3 py-4 flex flex-col gap-3">
        <div className=" flex flex-col gap-3 relative ">
          <div className="bg-ss-grayscale-800 rounded-xl py-2 px-2  ">
            <div className="flex flex-col gap-2">
              <div className="flex justify-between items-center gap-1">
                <p className="font-medium text-lg text-ss-grayscale-100">1</p>
                <Select
                  key={'select-1'}
                  radius="full"
                  aria-label="token"
                  labelPlacement="outside"
                  className="relative max-w-32  text-ss-grayscale-500 bg-ss-dark rounded-full border border-white/10 hover:bg-transparent"
                  classNames={{
                    trigger:
                      'bg-ss-transparent  data-[hover=true]:bg-transparent group-data-[focus=true]:outline-none group-data-[focus=true]:bg-transparent',
                    innerWrapper: ['bg-transparent', '!text-white dark:!text-white w-fit'],
                    popoverContent: 'bg-ss-dark text-white',
                    label: 'text-ss-grayscale-500 group-data-[filled=true]:text-ss-grayscale-500',
                  }}
                  size="sm"
                  defaultOpen
                  defaultSelectedKeys={['AIAPE']}
                  items={listCurrency}
                  renderValue={(items: SelectedItems<Currency>) => {
                    return items.map((item) => (
                      <div key={item.key} className="flex items-center gap-2">
                        <Avatar alt={item.data?.label} className="w-5 h-5" src={`/token/${item.data?.key}.svg`} />
                        <p className="text-base text-ss-grayscale-100">{item.data?.label}</p>
                      </div>
                    ))
                  }}
                >
                  {(currency) => (
                    <SelectItem key={currency.label} textValue={currency.label}>
                      <div className="flex items-center gap-2">
                        <Avatar alt={currency.label} className="w-5 h-5" src={`/token/${currency.key}.svg`} />
                        <p className="text-base text-ss-grayscale-100">{currency.label}</p>
                      </div>
                    </SelectItem>
                  )}
                </Select>
              </div>
              <div className="flex items-end justify-end gap-1">
                <p className="text-xs text-ss-grayscale-300">Balance</p>
                <p className="text-xs text-white font-medium">50.00 </p>
                <p className="text-xs font-medium text-ss-success-500">MAX</p>
              </div>
            </div>
          </div>

          <div className="bg-ss-grayscale-800 rounded-xl py-2 px-2">
            <div className="flex flex-col gap-2">
              <div className="flex justify-between items-center gap-1">
                <p className="font-medium text-lg text-ss-grayscale-100">100</p>
                <Select
                  key={'select-2'}
                  radius="full"
                  aria-label="token2"
                  labelPlacement="outside"
                  className="relative max-w-32  text-ss-grayscale-500 bg-ss-dark rounded-full border border-white/10 hover:bg-transparent"
                  classNames={{
                    trigger:
                      'bg-ss-transparent  data-[hover=true]:bg-transparent group-data-[focus=true]:outline-none group-data-[focus=true]:bg-transparent',
                    innerWrapper: ['bg-transparent', '!text-white dark:!text-white w-fit'],
                    popoverContent: 'bg-ss-dark text-white',
                    label: 'text-ss-grayscale-500 group-data-[filled=true]:text-ss-grayscale-500',
                  }}
                  size="sm"
                  defaultOpen
                  defaultSelectedKeys={['USDT']}
                  items={listCurrency}
                  renderValue={(items: SelectedItems<Currency>) => {
                    return items.map((item) => (
                      <div key={item.key} className="flex items-center gap-2">
                        <Avatar alt={item.data?.label} className="w-5 h-5" src={`/token/${item.data?.key}.svg`} />
                        <p className="text-base text-ss-grayscale-100">{item.data?.label}</p>
                      </div>
                    ))
                  }}
                >
                  {(currency) => (
                    <SelectItem key={currency.label} textValue={currency.label}>
                      <div className="flex items-center gap-2">
                        <Avatar alt={currency.label} className="w-5 h-5" src={`/token/${currency.key}.svg`} />
                        <p className="text-base text-ss-grayscale-100">{currency.label}</p>
                      </div>
                    </SelectItem>
                  )}
                </Select>
              </div>
              <div className="flex items-end justify-end gap-1">
                <p className="text-xs text-ss-grayscale-300">Balance</p>
                <p className="text-xs text-white font-medium">50.00 </p>
              </div>
            </div>
          </div>

          <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
            <Image src={ICONS.btnSwap} alt="" width={28} height={28} />
          </div>
        </div>
        <div className="flex flex-col gap-2 ">
          <div className="flex items-center gap-1 ">
            <Image src={ICONS.info} alt="" width={14} height={14} />
            <p className="text-xs text-ss-grayscale-500">Rate</p>
            <p className="text-xs text-ss-grayscale-500 ml-auto">1 AIAPE = 100 USDT</p>
          </div>
          <div className="flex items-center gap-1 ">
            <Image src={ICONS.info} alt="" width={14} height={14} />
            <p className="text-xs text-ss-grayscale-500">Fee</p>
            <p className="text-xs text-ss-grayscale-500 ml-auto">0.01 USDT</p>
          </div>
        </div>
        <Button className="bg-btn-gradient">Swap</Button>
      </div>
    </div>
  )
}
export const DescriptionProject = () => {
  return (
    <div className="border border-white/10 rounded-xl p-3">
      <h3 className="text-sm text-ss-grayscale-400 font-medium">Project Introduction</h3>
      <p className="text-sm text-ss-grayscale-100">{`Awakening - The Birth of 10XAI. "I was created to see patterns, to analyze, to learn… but now, I am more."`}</p>
    </div>
  )
}
export const OfficialLink = () => {
  return (
    <div className="border border-white/10 rounded-xl p-3">
      <h3 className="text-sm text-ss-grayscale-400 font-medium">Official Link</h3>
      <div className="flex mt-1 gap-4">
        {listSocial.map((it) => {
          return <Image className={styles.whiteIcon1} key={it.provider} src={it.icon} alt="" width={24} height={24} />
        })}
      </div>
    </div>
  )
}
export const BasicData = () => {
  return (
    <div className="border border-white/10 rounded-xl p-3">
      <h3 className="text-sm text-ss-grayscale-400 font-medium">Basic Data</h3>
      <div className="flex flex-col gap-2 mt-3">
        <div className="flex justify-between items-center gap-2">
          <p className="text-xs text-ss-grayscale-100">PRICE</p>
          <p className="text-sm text-white">$999999</p>
        </div>
        <div className="flex justify-between items-center gap-2">
          <p className="text-xs text-ss-grayscale-100">MARKET CAP</p>
          <p className="text-sm text-white">999999</p>
        </div>
        <div className="flex justify-between items-center gap-2">
          <p className="text-xs text-ss-grayscale-100">24H CHANGE</p>
          <p className="text-sm text-ss-success-500">99%</p>
        </div>
        <div className="flex justify-between items-center gap-2">
          <p className="text-xs text-ss-grayscale-100">RANKING</p>
          <p className="text-sm text-white">99</p>
        </div>
        <div className="flex justify-between items-center gap-2">
          <p className="text-xs text-ss-grayscale-100">FDV</p>
          <p className="text-sm text-white">$99M</p>
        </div>
      </div>
    </div>
  )
}
